let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jtXXq"), load("tLGOl")]).then(() => parcelRequire('anKEx'));